<input #input
       [ngModel]="Text"
       (ngModelChange)="onChange($event)"
       [class]="TextBoxClass" 
       placeholder="{{Watermark}}" 
       autocomplete="off"
       [readonly]="IsReadOnly"
       [disabled]="IsDisabled"
       (keyup)="onKeyUp($event)"
       (keydown)="onKeyDown($event)"
       (blur)="onBlur($event)"
       (focus)="onFocus($event)"/>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/boxes/text-box/text-box.html